<template>
  <section class="py-8 lg:py-16" :style="{ backgroundColor: bgColor }" aria-labelledby="references-title">
   <div class="px-6 mx-auto max-w-5xl xl:px-0">
    <div class="text-lg xl:text-xl font-ww-bold" id="references-title" v-html="title"></div>

<div class="mt-4 text-xs text-ww-regular xl:text-sm" v-html="referencesHtml"></div>
   </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  bgColor: {
    type: String,
    default: '#F6F6F6'
  },
  title: {
    type: String,
    default: 'References:'
  },
  referencesHtml: {
    type: String,
    default:
      '[1] Raz, N., et al. (2005). Regional brain changes in aging healthy adults: general trends, individual differences and modifiers. Cerebral Cortex, 15(2), 167-179.<br>[2] Mitchell, G.F., et al. (2007). Arterial stiffness, pressure and flow pulsatility and brain structure and function. Brain, 130(Pt 4), 1513-1523.'
  }
})

defineBuilderComponent({
  friendlyName: 'References With Background',
  inputs: [
    { name: 'bgColor', type: 'color', defaultValue: '#F6F6F6' },
    { name: 'title', type: 'richText', defaultValue: 'References:' },
    { name: 'referencesHtml', type: 'richText', defaultValue: '[1] Raz, N., et al. (2005). Regional brain changes in aging healthy adults: general trends, individual differences and modifiers. Cerebral Cortex, 15(2), 167-179.<br>[2] Mitchell, G.F., et al. (2007). Arterial stiffness, pressure and flow pulsatility and brain structure and function. Brain, 130(Pt 4), 1513-1523.' }
  ]
})
</script>